/**
 * Config file for the App. Sets URLs based on environment, prod or dev.
 * @module config
 */


let isPopOutInDev = false;
let origin = "http://localhost:3000";
if (typeof window !== 'undefined') {
  isPopOutInDev = process.env.NODE_ENV === "development" && window.location.host === "localhost:3000";
  origin = window.location.origin;
}




export const clientConfig = {
  viewerUrl: () => {
    const paths = {
      production: "https://author.quickpoint.me/viewer/index.html",
      staging: "https://stage-author.quickpoint.me/viewer/index.html",
      development: "/viewer/index.html",
      test: "/viewer/index.html",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  // single users worker: POST /check, /register, /owners
  users: () => {
    const paths = {
      production: "https://users-production.quickpointme.workers.dev",
      staging: "https://users-staging.quickpointme.workers.dev",
      development: "/users",
      test: "http://testing/users",
      honoTest: "http://0.0.0.0:9000",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlGetFile: () => {
    const paths = {
      production: "https://gql-get-file-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-get-file-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-get-file`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9003/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlGetFilter: () => {
    const paths = {
      production: "https://gql-get-filter-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-get-filter-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-get-filter`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9004/graphql",
    };

    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  getFont: () => {
    const paths = {
      production: "https://get-font-production.quickpointme.workers.dev",
      staging: "https://get-font-staging.quickpointme.workers.dev",
      development: "/get-font",
      test: "http://testing/get-font-url",
      honoTest: "http://0.0.0.0:9005",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlGetStack: () => {
    const paths = {
      production: "https://gql-get-stack-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-get-stack-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-get-stack`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9006/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlViewFile: () => {
    const paths = {
      production: "https://gql-view-file-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-view-file-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-view-file`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9007/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlViewStack: () => {
    const paths = {
      production: "https://gql-view-stack-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-view-stack-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-view-stack`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9008/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlWriteFile: () => {
    const paths = {
      production: "https://gql-write-file-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-write-file-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-write-file`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9009/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlWriteFilter: () => {
    const paths = {
      production: "https://gql-write-filter-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-write-filter-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-write-filter`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9010/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlWriteStack: () => {
    const paths = {
      production: "https://gql-write-stack-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-write-stack-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-write-stack`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9011/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlWriteUserRecord: () => {
    const paths = {
      production: "https://gql-write-user-record-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-write-user-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-write-user-record`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9012/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  gqlGenerateAiImage: () => {
    const paths = {
      production: "https://ai-image-generator-production.quickpointme.workers.dev/graphql",
      staging: "https://ai-image-generator-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/gql-ai-image`,
      test: "http://testing/gql-ai-image",
      honoTest: "http://0.0.0.0:9026/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },

  heatmapCollector: () => {
    const paths = {
      production: "https://heatmap-collector.quickpointme.workers.dev",
      staging: "https://heatmap-collector-staging.quickpointme.workers.dev",
      development: "/heatmap-collector",
      test: "http://testing/heatmap-collector",
      honoTest: "http://0.0.0.0:9025/heatmap-collector",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },

  payments: () => {
    const paths = {
      production: "https://payments-production.quickpointme.workers.dev",
      staging: "https://payments-staging.quickpointme.workers.dev",
      development: `${origin}/payments-api`,
      test: "http://testing",
      honoTest: "http://0.0.0.0:9030",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },

  support: () => {
    const paths = {
      production: "https://support-production.quickpointme.workers.dev",
      staging: "https://support-staging.quickpointme.workers.dev",
      development: "http://localhost:9031",
      test: "http://testing",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },
  layoutAi: () => {
    const paths = {
      production: "https://gql-layout-ai-production.quickpointme.workers.dev",
      staging: "https://gql-layout-ai-staging.quickpointme.workers.dev",
      development: `${origin}/layout-ai`,
      test: "http://testing",
      honoTest: "http://0.0.0.0:9023",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },

  gqlLayoutAi: () => {
    const paths = {
      production: "https://gql-layout-ai-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-layout-ai-staging.quickpointme.workers.dev/graphql",
      development: `${origin}/layout-ai/graphql`,
      test: "http://testing/layout-ai/graphql",
      honoTest: "http://0.0.0.0:9023/graphql",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error: dynamic index
    return paths[process.env.NODE_ENV];
  },

  uploadDatafileUrl: ({ fileName, jwt, isPopOutInDev }: { fileName: string, jwt: string, isPopOutInDev?: boolean }) => {
    const paths = {
      production: `https://upload-datafile-url-production.quickpointme.workers.dev/${fileName}/${jwt}`,
      staging: `https://upload-datafile-url-staging.quickpointme.workers.dev/${fileName}/${jwt}`,
      development: `/upload-datafile-url/${fileName}/${jwt}`,
      test: `http://testing/upload-datafile-url/${fileName}/${jwt}`,
      honoTest: `http://0.0.0.0:9022/${fileName}/${jwt}`,
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error dynamic
    return paths[process.env.NODE_ENV];
  },

  uploadImageUrl: (jwt: string, isPopOutInDev?: boolean) => {
    const paths = {
      production: `https://upload-image-url-production.quickpointme.workers.dev/${jwt}`,
      staging: `https://upload-image-url-staging.quickpointme.workers.dev/${jwt}`,
      development: `/upload-image-url/${jwt}`,
      test: `http://testing/upload-image-url/${jwt}`,
      honoTest: `http://0.0.0.0:9013/${jwt}`,
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error dynamic
    return paths[process.env.NODE_ENV];
  },

  vespaTransfer: (env: "production" | "development" | "staging") => {
    const paths = {
      production: "https://transfer-to-vespa-production.quickpointme.workers.dev",
      staging: "https://transfer-to-vespa-staging.quickpointme.workers.dev",
      development: "http://0.0.0.0:9015",
    };
    return paths[env];
  },

  authorUrl: () => {
    const paths = {
      production: "https://quickpoint.me/author",
      staging: "http://localhost:3000/author",
      development: "http://localhost:3000/author",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error dynamic
    return paths[process.env.NODE_ENV];
  },

  mobilePreviewUrl: () => {
    const paths = {
      production: "/viewer/index.html",
      staging: "/viewer/index.html",
      development: "/viewer/index.html",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error dynamic
    return paths[process.env.NODE_ENV];
  },

  pdfExport: (owner: string, stack: string) => {
    const paths = {
      production: `https://pdf-export-production.quickpointme.workers.dev/pdf/${owner}/${stack}`,
      staging: `https://pdf-export-staging.quickpointme.workers.dev/pdf/${owner}/${stack}`,
      development: `/pdf-export/pdf/${owner}/${stack}`,
      test: `http://testing/pdf/${owner}/${stack}`,
      honoTest: `http://0.0.0.0:9029/pdf/${owner}/${stack}`,
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error dynamic
    return paths[process.env.NODE_ENV];
  },

  // JWT-protected endpoint that renders the author's CURRENT stack posted in the
  // body — works for unpublished drafts + EU decks (no published-KV lookup).
  pdfGenerate: () => {
    const paths = {
      production: "https://pdf-export-production.quickpointme.workers.dev/generate",
      staging: "https://pdf-export-staging.quickpointme.workers.dev/generate",
      development: "/pdf-export/generate",
      test: "http://testing/generate",
      honoTest: "http://0.0.0.0:9029/generate",
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    if (isPopOutInDev) return paths.development;
    // @ts-expect-error dynamic
    return paths[process.env.NODE_ENV];
  },

};
